import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Autoplay, FreeMode, Navigation, Thumbs } from "swiper";
import "../../css/pages/slider.scss";
import { iContent } from "./ContentShow";
import { NavLink } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { withErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../helpers/ErrorFallback";
import { useGetPosts } from "../../queries";

interface Props {
  category: string;
}

const Slider: React.FC<Props> = (Props) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  const { data: relatedContents, isLoading: postsLoading } = useGetPosts();
  return (
    <>
      {postsLoading ? (
        <Skeleton variant="rectangular" height="50vh" className="swiper" />
      ) : (
        <>
          <Swiper
            loop={true}
            spaceBetween={10}
            navigation={true}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[Autoplay, FreeMode, Navigation, Thumbs]}
            autoplay={{
              delay: 5000,
            }}
          >
            {relatedContents.map((value: iContent) => (
              <SwiperSlide key={value.id}>
                <div className="sliderImageTitleDate">
                  <img src={require(`../../${value.coverImage}`)} alt="logo" />
                  <NavLink
                    className="navLink"
                    to={`/${Props.category}/${value.id}`}
                  >
                    <div className="sliderTitleDate">
                      <div> {value.title}</div>
                    </div>
                  </NavLink>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
    </>
  );
};

export default withErrorBoundary(Slider, {
  FallbackComponent: ErrorFallback,
});
